/*
 * "Há N novas respostas" — a barra que aparece quando chegam posts pelo
 * realtime enquanto o leitor está no meio do tópico. No fim do tópico o
 * flarum/realtime já acrescenta o post direto no stream, e a barra não
 * aparece; no meio, ele só atualiza a contagem, e é aí que ela avisa.
 */
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import { t } from '../../utils/settings';
export default class NewRepliesBar extends Component {
  view() {
    const {
      discussion,
      stream,
      page
    } = this.attrs;
    const count = discussion.commentCount() || 0;
    if (page.canelaSeenCount === undefined || stream.viewingEnd()) page.canelaSeenCount = count;
    const fresh = count - page.canelaSeenCount;
    if (fresh <= 0) return null;
    return m("div", {
      className: "CanelaNewReplies",
      role: "status"
    }, m("button", {
      type: "button",
      className: "CanelaNewReplies-button",
      onclick: () => {
        page.canelaSeenCount = count;
        stream.goToLast();
      }
    }, m(Icon, {
      name: "fas fa-arrow-down"
    }), t('topic.new_replies', {
      count: fresh
    })));
  }
}
flarum.reg.add('ramon-canela', 'forum/topic/components/NewRepliesBar', NewRepliesBar);